import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "members-panel" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "h5" }, "Members", -1)
const _hoisted_3 = {
  key: 0,
  class: "members-panel__note"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Please note you may be charged for each member added. View our ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("pricing plans")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" for more information on how our team plans and billing works. ")
const _hoisted_7 = { class: "members-panel__header" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Add members ")
const _hoisted_9 = { class: "members-panel__search" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "dropdown-sub" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "dropdown-sub" }
const _hoisted_14 = {
  key: 1,
  class: "members-panel__filter-empty"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Unfortunately, we couldn't find users that match your criteria", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("section", { class: "confirmation-for-removal" }, [
  /*#__PURE__*/_createElementVNode("p", null, " You will lose all the information stored related to the team member. There's no going back once you delete your team member! ")
], -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Remove Team Member ")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("section", { class: "confirmation-for-removal" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Team ownership can only be passed to a team member with Admin permissions. Please grant Admin permissions to the team member first. ")
], -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("section", { class: "confirmation-for-removal" }, [
  /*#__PURE__*/_createElementVNode("p", null, " You are about to pass team ownership to another Admin. You will lose team ownership and become an Admin. Are you sure? ")
], -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Confirm")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppButtonMini = _resolveComponent("AppButtonMini")!
  const _component_AppTooltip = _resolveComponent("AppTooltip")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_AppDropdown = _resolveComponent("AppDropdown")!
  const _component_UserItem = _resolveComponent("UserItem")!
  const _component_UserTable = _resolveComponent("UserTable")!
  const _component_AddMemberModal = _resolveComponent("AddMemberModal")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.isCurrentUserOwner)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_router_link, { to: "/settings#plans" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _hoisted_6
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_7, [
      (_ctx.currentUserOrgAdmin)
        ? (_openBlock(), _createBlock(_component_AppButton, {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ModalHandlerService.open('add-members-modal'))),
            class: "members-panel__add-members"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_AppInput, {
          id: "members-search",
          label: "",
          modelValue: _ctx.searchValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchValue) = $event)),
          placeholder: "Search members",
          type: "text",
          icon: "search",
          error: false,
          autofocus: ""
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("section", null, [
      (_ctx.$store.getters['teams/getActiveTeamPendingInvites'].length && _ctx.filteredTeamInvites)
        ? (_openBlock(), _createBlock(_component_UserTable, {
            key: 0,
            headingLeft: "Pending invites",
            headingRight: _ctx.currentUserOrgAdmin ? 'Access level' : undefined,
            class: "members-panel__pending-users"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters['teams/getActiveTeamPendingInvites'], (user) => {
                return _withDirectives((_openBlock(), _createBlock(_component_UserItem, {
                  key: user.email,
                  user: user
                }, {
                  default: _withCtx(() => [
                    (_ctx.currentUserOrgAdmin)
                      ? (_openBlock(), _createBlock(_component_AppTooltip, {
                          key: 0,
                          title: "Resend invite",
                          onClick: _withModifiers(($event: any) => (_ctx.sendTeamInviteRequest(user)), ["prevent"]),
                          class: "col-6"
                        }, {
                          default: _withCtx((props) => [
                            _createVNode(_component_AppButtonMini, {
                              icon: "envelope",
                              onMouseenter: ($event: any) => (props.visibility.update(true)),
                              onMouseleave: ($event: any) => (props.visibility.update(false))
                            }, null, 8, ["onMouseenter", "onMouseleave"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.currentUserOrgAdmin)
                      ? (_openBlock(), _createBlock(_component_AppDropdown, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AppSelect, {
                              modelValue: user.role,
                              "onUpdate:modelValue": ($event: any) => ((user.role) = $event),
                              modelModifiers: { lazy: true },
                              options: _ctx.changeRoleOptions,
                              "label-by": "label",
                              "value-by": "label",
                              min: 1,
                              "open-direction": "top",
                              loading: _ctx.usersUpdating.includes(user.email),
                              "close-on-select": true,
                              class: "no-border vue-select--right-aligned",
                              onSelected: ($event: any) => (_ctx.handleChangeRolePendingUsers(user, $event.label)),
                              onRemoved: ($event: any) => (_ctx.saveLastUpdatedPendingUser(user, $event))
                            }, {
                              toggle: _withCtx(({ isFocusing, toggle }) => [
                                _createElementVNode("div", {
                                  onClick: toggle,
                                  onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent","stop"])),
                                  class: _normalizeClass(["app-dropdown__vue-select-trigger", { active: isFocusing }])
                                }, [
                                  _createVNode(_component_AppIcon, { name: "arrow" })
                                ], 42, _hoisted_10)
                              ]),
                              label: _withCtx(({ selected }) => [
                                _createTextVNode(_toDisplayString(selected ? selected.label : 'Please select'), 1)
                              ]),
                              "dropdown-item": _withCtx(({ option }) => [
                                _createElementVNode("p", {
                                  class: _normalizeClass(["dropdown-title", option.class])
                                }, _toDisplayString(option.label), 3),
                                _createElementVNode("p", _hoisted_11, _toDisplayString(option.description), 1)
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "options", "loading", "onSelected", "onRemoved"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["user"])), [
                  [_vShow, !_ctx.searchValue || _ctx.searchValue && user.email.includes(_ctx.searchValue)]
                ])
              }), 128))
            ]),
            _: 1
          }, 8, ["headingRight"]))
        : _createCommentVNode("", true),
      (_ctx.showTeamMembersTable)
        ? (_openBlock(), _createBlock(_component_UserTable, {
            key: 1,
            headingLeft: "User",
            headingRight: _ctx.currentUserOrgAdmin ? 'Access level' : undefined,
            headingMiddle: "Teams"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeTeamMembers, (user) => {
                return _withDirectives((_openBlock(), _createBlock(_component_UserItem, {
                  key: user.email,
                  twoColumnsLayout: !_ctx.currentUserOrgAdmin,
                  user: user
                }, {
                  default: _withCtx(() => [
                    (_ctx.currentUserOrgAdmin)
                      ? (_openBlock(), _createBlock(_component_AppDropdown, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_AppSelect, {
                              modelValue: user.role,
                              "onUpdate:modelValue": ($event: any) => ((user.role) = $event),
                              modelModifiers: { lazy: true },
                              options: _ctx.changeRoleOptions,
                              "label-by": "label",
                              "value-by": "label",
                              min: 1,
                              loading: _ctx.usersUpdating.includes(user.email),
                              onSelected: ($event: any) => (_ctx.handleChangeRoleTeamMembers(user, $event.label)),
                              onRemoved: ($event: any) => (_ctx.saveLastUpdatedTeamMember(user, $event)),
                              class: "no-border vue-select--right-aligned",
                              "close-on-select": true,
                              "disabled-by": (option) => _ctx.disableOptions(user.role, option.label)
                            }, {
                              toggle: _withCtx(({ isFocusing, toggle }) => [
                                _createElementVNode("div", {
                                  onClick: toggle,
                                  onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent","stop"])),
                                  class: _normalizeClass(["app-dropdown__vue-select-trigger", { active: isFocusing }])
                                }, [
                                  _createVNode(_component_AppIcon, { name: "arrow" })
                                ], 42, _hoisted_12)
                              ]),
                              label: _withCtx(({ selected }) => [
                                _createTextVNode(_toDisplayString(selected ? selected.label : 'Please select'), 1)
                              ]),
                              "dropdown-item": _withCtx(({ option }) => [
                                _createElementVNode("p", {
                                  class: _normalizeClass(["dropdown-title", option.class])
                                }, _toDisplayString(option.label), 3),
                                _createElementVNode("p", _hoisted_13, _toDisplayString(option.description), 1)
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue", "options", "loading", "onSelected", "onRemoved", "disabled-by"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["twoColumnsLayout", "user"])), [
                  [_vShow, !_ctx.searchValue || _ctx.searchValue && user.email.includes(_ctx.searchValue)]
                ])
              }), 128))
            ]),
            _: 1
          }, 8, ["headingRight"]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.filteredUsers && _ctx.hasUsers)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
      : _createCommentVNode("", true),
    _createVNode(_component_AddMemberModal, { id: "add-members-modal" }),
    _createVNode(_component_Modal, {
      id: "confirmation-for-removal",
      title: `Remove ${_ctx.userForRemoval && _ctx.userForRemoval.email ? _ctx.userForRemoval.email : ''}`
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_AppButton, {
          theme: "secondary",
          onClick: _ctx.handleCloseTeamMemberRemovalModal
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_AppButton, {
          theme: "danger",
          onClick: _ctx.handleRemoveTeamMember,
          loading: _ctx.asyncActionInProgress
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      default: _withCtx(() => [
        _hoisted_17
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_Modal, {
      id: "set-admin-first",
      title: "Set admin role first"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_AppButton, {
          class: "close-btn",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.ModalHandlerService.close()))
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _hoisted_20
      ]),
      _: 1
    }),
    (_ctx.newOwner)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          id: "pass-ownership",
          title: `Passing ownership to ${_ctx.newOwner.userProfile?.firstName} ${_ctx.newOwner.userProfile?.lastName}`
        }, {
          actions: _withCtx(() => [
            _createVNode(_component_AppButton, {
              theme: "secondary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.ModalHandlerService.close()))
            }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            }),
            _createVNode(_component_AppButton, {
              onClick: _ctx.handleChangeOwnership,
              loading: _ctx.changeOwnershipLoading
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            }, 8, ["onClick", "loading"])
          ]),
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ]))
}